import React from 'react';
import { useParams } from 'react-router-dom';
import { useQuery } from '@apollo/client';
import AuthenticationForm from './AuthenticationForm';
import { mandantSettings } from '../../queries/mandantSetting';
import { getAgbLink } from '../../queries/mandantLink';
import { MANDANT_BY_REGISTERID } from './MandantRegisterHeadline';

export const RegisterAtMandant = ({ history, location }) => {
  const { mandantRegisterId } = useParams();

  const { data, loading } = useQuery(mandantSettings, {
    variables: { registerId: mandantRegisterId },
    pollInterval: 60 * 1000,
  });

  const { data: agbData, loading: agbLoading } = useQuery(getAgbLink, {
    variables: { registerId: mandantRegisterId },
    pollInterval: 60 * 1000,
  });

  const { data: mandantData, loading: mandantLoading } = useQuery(
    MANDANT_BY_REGISTERID,
    {
      variables: { mandantRegisterId },
      pollInterval: 60 * 1000,
    }
  );

  if (loading || agbLoading || mandantLoading) {
    return null;
  }

  return (
    <AuthenticationForm
      history={history}
      location={location}
      mandantSettings={data?.getMandantSettings}
      agbLink={agbData?.getAgbLink}
      mandantName={mandantData?.mandantByRegisterId?.name}
      purpose="registerAtMandant"
    />
  );
};

export default RegisterAtMandant;
